// External libraries
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Paper from '@mui/material/Paper';

// Internal imports - state
import { store } from 'src/state/dynamic-store';
import { RootState } from '@state/root-state.ts';

// Internal imports - components
import { QuantityUnitsComponentWrapper } from '@sharedComponents/quantity-units/QuantityUnitsComponent';
import { CdfBreadcrumbs } from '@commonComponents/navigation/CdfBreadcrumbs';

// Styles
import styles from './QuantityUnitsPage.module.scss';

export function QuantityUnitsPage() {
  const { t } = useTranslation(['layouts']);
  const organizationId = useSelector((state: RootState) => state.appContext.selectedOrganizationId) ?? '';

  return (
    <>
      <CdfBreadcrumbs items={[{ label: t('breadCrumbs.quantityUnits.page') }]} />
      <Paper className={styles.container}>
        <QuantityUnitsComponentWrapper organizationId={organizationId} store={store} />
      </Paper>
    </>
  );
}
